export default __webpack_public_path__ + "static/media/Saibaba4.3f1fa081.jpg";